import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Container,
  TextField,
  Button,
  Grid,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Box,
  Typography,
  CircularProgress,
} from '@mui/material';
import {
  FaBoxOpen,
  FaCalendarAlt,
  FaBarcode,
  FaTag,
  FaTools,
  FaBuilding,
  FaMapMarkerAlt,
  FaTruckLoading,
  FaFileInvoice,
  FaInfoCircle,
  FaSave,
  FaListUl,
  FaSearch,
  FaFileExcel,
  FaMap
} from 'react-icons/fa';
import {
  getArea,
  getRol,
  getEquipo,
  getEquipoact,
  getSO,
  getMarca,
  getTipoequipo,
  getTipodeequipo,
  postactivo,
  updateActivo,
  getCritici,
  postTipoequipo,
  postTipodeequipo,
  getAllusuarios
} from '../../../redux/actions';
import Swal from 'sweetalert2';
import styles from './CrearActivos.module.css';

const FormularioEquipo = () => {
  const dispatch = useDispatch();
  const marcaAct = useSelector((state) => state.marca || []);
  const tipoequipoAct = useSelector((state) => state.tipoequipo || []);
  const tipodeequipoAct = useSelector((state) => state.tipodeequipo || []);
  const criticidadAct = useSelector((state) => state.criticidad || []);
  const equipos = useSelector((state) => state.equiact || []);
  const allusuarios = useSelector((state) => {
    const rawUsers = state.allusuarios;
    if (rawUsers && Array.isArray(rawUsers.usuarios)) {
      return rawUsers.usuarios;
    }
    return Array.isArray(rawUsers) ? rawUsers : [];
  });
  const [loadingEquipos, setLoadingEquipos] = useState(false);

  const fetchEquiposAct = async () => {
    setLoadingEquipos(true);
    await dispatch(getEquipoact());
    setLoadingEquipos(false);
  };

  useEffect(() => {
    dispatch(getSO());
    dispatch(getMarca());
    dispatch(getTipoequipo());
    dispatch(getTipodeequipo());
    dispatch(getCritici());
    dispatch(getEquipoact()); // Load all equipments including Proceso = 2
    dispatch(getAllusuarios()); // Load all users
  }, [dispatch]);

  const errorPost = useSelector((state) => state.errorPost);

  useEffect(() => {
    if (errorPost) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: errorPost
      });
    }
  }, [errorPost]);

  const tipoequipoOrdenado = [...tipoequipoAct].sort((a, b) =>
    a.descripcionte.localeCompare(b.descripcionte)
  );

  const tipodeequipoOrdenado = [...(tipodeequipoAct || [])].sort((a, b) =>
    a.descripcion.localeCompare(b.descripcion)
  );

  const marcaOrdenada = [...marcaAct].sort((a, b) =>
    a.marca.localeCompare(b.marca, 'es', { sensitivity: 'base' })
  );

  const criticidadOrdenado = [...criticidadAct].sort((a, b) =>
    a.descripcion.localeCompare(b.descripcion, 'es', { sensitivity: 'base' })
  );

  const usuariosOrdenados = [...(allusuarios || [])].sort((a, b) =>
    a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' })
  );

  const [formValues, setFormValues] = useState({
    codigo: '',
    fechaIngreso: '',
    equipo: '',
    tipoEquipo: '',
    marca: '',
    modeloTipo: '',
    serie: '',
    costoUnitario: '',
    sede: '',
    dependencia: '',
    ubicacion_area: '',
    proveedor: '',
    factura: '',
    nit: '',
    estado: '',
    observacion: '',
    esGestionTI: false,
    usuarioId: '',
  });

  const [openModal, setOpenModal] = useState(false);
  const [openTipoModal, setOpenTipoModal] = useState(false);
  const [creatingField, setCreatingField] = useState('');
  const [nuevoTipo, setNuevoTipo] = useState('');
  const [page, setPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [codError, setCodError] = useState(false);
  const [serieError, setSerieError] = useState(false);
  const [editId, setEditId] = useState(null);
  const rowsPerPage = 10;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filteredEquipos = useMemo(() => {
    const term = searchTerm.toLowerCase();
    return equipos.filter((item) => {
      return (
        item.equipo?.cod?.toLowerCase().includes(term) ||
        item.equipo?.modelo?.toLowerCase().includes(term) ||
        item.marca?.marca?.toLowerCase().includes(term) ||
        item.tipoequipo?.descripcionte?.toLowerCase().includes(term)
      );
    });
  }, [equipos, searchTerm]);

  const paginatedData = filteredEquipos.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const formatCurrency = (value) => {
    if (!value) return '';
    const formattedValue = value
      .replace(/\D/g, '')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `$ ${formattedValue}`;
  };

  const parseCurrency = (value) => {
    return value.replace(/\./g, '').replace('$', '').trim();
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (name === 'codigo') {
      const exists = equipos.some(item => item.equipo && item.equipo.cod && String(item.equipo.cod).toLowerCase() === String(value).toLowerCase() && item.equipo.id !== editId);
      setCodError(exists);
    }
    if (name === 'serie' && value.trim() !== '' && value !== '0') {
      const exists = equipos.some(item => item.equipo && item.equipo.serial && String(item.equipo.serial).toLowerCase() === String(value).toLowerCase() && item.equipo.id !== editId);
      setSerieError(exists);
    }

    if ((name === 'equipo' || name === 'tipoEquipo') && value === 'crear_nuevo') {
      setCreatingField(name);
      setOpenTipoModal(true);
      return;
    }
    if (name === 'costoUnitario') {
      setFormValues({
        ...formValues,
        [name]: formatCurrency(value),
      });
    } else {
      setFormValues({
        ...formValues,
        [name]: type === 'checkbox' ? checked : value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredFields = [
      'codigo',
      'fechaIngreso',
      'equipo',
      'marca',
      'modeloTipo',
      'serie',
      'costoUnitario',
    ];

    for (const field of requiredFields) {
      if (!formValues[field]) {
        Swal.fire({
          icon: 'warning',
          title: 'Campos incompletos',
          text: 'Por favor, completa todos los campos marcados como obligatorios.',
        });
        return;
      }
    }

    if (codError || serieError) {
      Swal.fire({
        icon: 'error',
        title: 'Error de validación',
        text: 'Por favor, corrige los campos marcados en rojo que ya existen en la base de datos antes de continuar.',
      });
      return;
    }

    const activo = {
      cod: formValues.codigo,
      fechacompra: formValues.fechaIngreso,
      tipoequipoId: formValues.equipo ? parseInt(formValues.equipo, 10) : null,
      tipodeequipoId: formValues.tipoEquipo ? parseInt(formValues.tipoEquipo, 10) : null,
      MarcaId: parseInt(formValues.marca, 10),
      modelo: formValues.modeloTipo,
      serial: formValues.serie,
      valor: parseCurrency(formValues.costoUnitario),
      sede: formValues.sede,
      dependencia: formValues.dependencia,
      ubicacion_area: formValues.ubicacion_area,
      proveedor: formValues.proveedor,
      factura: formValues.factura,
      nit: formValues.nit,
      estado: formValues.estado,
      observacion: formValues.observacion,
      Proceso: formValues.esGestionTI ? null : 2,
      Nombrequipo: tipoequipoOrdenado.find(t => t.id === parseInt(formValues.equipo, 10))?.descripcionte?.toUpperCase() || '',
      UsuarioId: formValues.usuarioId ? parseInt(formValues.usuarioId, 10) : null,
    };

    let result;
    if (editId) {
      result = await dispatch(updateActivo(editId, activo));
      if (result.type === 'UPDATE_ACTIVO_SUCCESS') {
        Swal.fire({
          icon: 'success',
          title: 'Activo Actualizado',
          text: 'La información del equipo ha sido actualizada exitosamente.',
        });

        setEditId(null);
        setFormValues({
          codigo: '',
          fechaIngreso: '',
          equipo: '',
          tipoEquipo: '',
          marca: '',
          modeloTipo: '',
          serie: '',
          costoUnitario: '',
          sede: '',
          dependencia: '',
          ubicacion_area: '',
          proveedor: '',
          factura: '',
          nit: '',
          estado: '',
          observacion: '',
          esGestionTI: false,
          usuarioId: '',
        });
        
        // Refrescar inventario
        dispatch(getEquipoact());
      }
    } else {
      result = await dispatch(postactivo(activo));
      if (result.type === 'POST_EQUIPO_SUCCESS') {
        Swal.fire({
          icon: 'success',
          title: 'Activo Registrado',
          text: 'La información del equipo ha sido guardada exitosamente.',
        });

        // Refrescar inventario
        dispatch(getEquipoact());

        setFormValues({
          codigo: '',
          fechaIngreso: '',
          equipo: '',
          tipoEquipo: '',
          marca: '',
          modeloTipo: '',
          serie: '',
          costoUnitario: '',
          sede: '',
          dependencia: '',
          ubicacion_area: '',
          proveedor: '',
          factura: '',
          nit: '',
          estado: '',
          observacion: '',
          esGestionTI: false,
          usuarioId: '',
        });
      }
    }
  };

  const handleOpenModal = () => {
    dispatch(getEquipoact());
    setOpenModal(true);
  };
  const handleCloseModal = () => setOpenModal(false);

  const handleCreateTipoEquipo = async () => {
    if (!nuevoTipo.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Campo vacío',
        text: 'Por favor ingresa un nombre.',
      });
      return;
    }

    let result;
    if (creatingField === 'tipoEquipo') {
      result = await dispatch(postTipodeequipo({ descripcion: nuevoTipo }));
    } else {
      result = await dispatch(postTipoequipo({ descripcionte: nuevoTipo }));
    }

    if (result && result.success) {
      Swal.fire({
        icon: 'success',
        title: 'Creado',
        text: 'Se ha creado exitosamente.',
      });
      setOpenTipoModal(false);
      setNuevoTipo('');
      if (result.data && result.data.id) {
         setFormValues(prev => ({ ...prev, [creatingField]: result.data.id }));
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: result.error || 'Ocurrió un error al crear el tipo de equipo.',
      });
    }
  };

  const exportToExcel = () => {
    const dataToExport = searchTerm ? filteredEquipos : equipos;

    if (!dataToExport || dataToExport.length === 0) {
      Swal.fire("Sin datos", "No hay datos para exportar", "warning");
      return;
    }

    const headers = [
      "Código",
      "Modelo",
      "Serial",
      "Tipo",
      "Marca",
      "Fecha ingreso",
      "Valor unitario",
      "Sede",
      "Dependencia",
      "Ubicación área",
      "Usuario Asignado",
      "Proveedor",
      "Factura",
      "Nit",
      "Observación"
    ];

    const rows = dataToExport.map(item => [
      item.equipo?.cod || "",
      item.equipo?.modelo || "",
      item.equipo?.serial || "",
      item.tipoequipo?.descripcionte || "",
      item.marca?.marca || "",
      item.equipo?.fechacompra
        ? new Date(item.equipo.fechacompra).toLocaleDateString("es-ES")
        : "",
      item.equipo?.valor ? item.equipo.valor.toLocaleString("es-CO") : "",
      item.equipo?.sede || "",
      item.equipo?.dependencia || "",
      item.equipo?.ubicacion_area || "",
      item.usuarioAsignado?.nombre || "Sin asignar",
      item.equipo?.proveedor || "",
      item.equipo?.factura || "",
      item.equipo?.nit || "",
      item.equipo?.observacion || ""
    ]);

    let csvContent =
      "data:text/csv;charset=utf-8," +
      [headers.join(","), ...rows.map(r => r.join(","))].join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "activos_estratificados.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Container className={styles.container}>
      <div className={styles.paper}>
        <header className={styles.header}>
          <h2 className={styles.title}>
            <FaBoxOpen /> Registro de Activos ISC
          </h2>
          <p className={styles.subtitle}>Incorpore nuevos equipos e infraestructura al inventario maestro de la compañía.</p>
        </header>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={4} className={styles.formGrid}>
            {/* SECCIÓN 1: DATOS BÁSICOS */}
            <Grid item xs={12}>
              <div className={styles.sectionLabel}>
                <FaInfoCircle /> Información General
              </div>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    className={styles.inputField}
                    name="codigo"
                    label="Código"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={formValues.codigo}
                    onChange={handleChange}
                    required
                    error={codError}
                    helperText={codError ? "Este código ya existe en bd" : ""}
                    InputProps={{
                      startAdornment: <FaBarcode style={{ color: '#94a3b8', marginRight: '10px' }} />,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    className={styles.inputField}
                    name="fechaIngreso"
                    label="Fecha de Ingreso"
                    type="date"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={formValues.fechaIngreso}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      startAdornment: <FaCalendarAlt style={{ color: '#94a3b8', marginRight: '10px' }} />,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    className={styles.inputField}
                    select
                    name="tipoEquipo"
                    label="Tipo equipo"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={formValues.tipoEquipo}
                    onChange={handleChange}
                  >
                    <MenuItem value=""><em>Seleccione...</em></MenuItem>
                    <MenuItem value="crear_nuevo" style={{ fontWeight: 'bold', color: '#2563eb' }}>
                      + Crear nuevo tipo de equipo
                    </MenuItem>
                    {tipodeequipoOrdenado.map((item) => (
                      <MenuItem key={item.id} value={item.id}>{item.descripcion}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    className={styles.inputField}
                    select
                    name="equipo"
                    label="Equipo"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={formValues.equipo}
                    onChange={handleChange}
                  >
                    <MenuItem value=""><em>Seleccione...</em></MenuItem>
                    <MenuItem value="crear_nuevo" style={{ fontWeight: 'bold', color: '#2563eb' }}>
                      + Crear nuevo equipo
                    </MenuItem>
                    {tipoequipoOrdenado.map((item) => (
                      <MenuItem key={item.id} value={item.id}>{item.descripcionte}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    className={styles.inputField}
                    select
                    name="marca"
                    label="Marca"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={formValues.marca}
                    onChange={handleChange}
                  >
                    <MenuItem value=""><em>Seleccione...</em></MenuItem>
                    {marcaOrdenada.map((item) => (
                      <MenuItem key={item.id} value={item.id}>{item.marca}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    className={styles.inputField}
                    name="modeloTipo"
                    label="Modelo / Tipo"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={formValues.modeloTipo}
                    onChange={handleChange}
                    InputProps={{
                      startAdornment: <FaTag style={{ color: '#94a3b8', marginRight: '10px' }} />,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    className={styles.inputField}
                    name="serie"
                    label="Nº de serie"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={formValues.serie}
                    onChange={handleChange}
                    required
                    error={serieError}
                    helperText={serieError ? "Este serial ya existe en bd" : ""}
                    InputProps={{
                      startAdornment: <FaTools style={{ color: '#94a3b8', marginRight: '10px' }} />,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    className={styles.inputField}
                    select
                    name="usuarioId"
                    label="Usuario Asignado"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={formValues.usuarioId}
                    onChange={handleChange}
                  >
                    <MenuItem value=""><em>Sin asignar / Ninguno</em></MenuItem>
                    {usuariosOrdenados.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.nombre} (Ced: {item.cedula})
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            </Grid>

            {/* SECCIÓN 2: UBICACIÓN Y ORIGEN */}
            <Grid item xs={12}>
              <div className={styles.sectionLabel}>
                <FaMapMarkerAlt /> Ubicación y Origen
              </div>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    className={styles.inputField}
                    select
                    name="sede"
                    label="Sede Principal"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={formValues.sede}
                    onChange={handleChange}
                  >
                    <MenuItem value=""><em>Seleccione...</em></MenuItem>
                    {["BARRANQUILLA", "BUENAVENTURA", "CARTAGENA", "CÚCUTA", "SANTA MARTA", "VENEZUELA"].sort((a, b) => a.localeCompare(b)).map(s => (
                      <MenuItem key={s} value={s}>{s}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    className={styles.inputField}
                    select
                    name="dependencia"
                    label="Dependencia / Depto"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={formValues.dependencia}
                    onChange={handleChange}
                  >
                    <MenuItem value=""><em>Seleccione...</em></MenuItem>
                    {["ADMINISTRACIÓN", "BUENAVENTURA", "CALENTURITAS", "COMPRAS", "CONTABILIDAD", "CONTROL Y REGISTRO", "CÚCUTA", "GERENCIA GENERAL", "GESTIÓN TI", "HSE", "LABORATORIO", "MANTENIMIENTO", "OPERACIONES", "PNSA", "RECEPCIÓN", "SANTA MARTA", "GESTIÓN HUMANA", "PREPARACIÓN", "JURIDICO"].sort((a, b) => a.localeCompare(b)).map(d => (
                      <MenuItem key={d} value={d}>{d}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    className={styles.inputField}
                    name="ubicacion_area"
                    label="Área Específica"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={formValues.ubicacion_area}
                    onChange={handleChange}
                    InputProps={{
                      startAdornment: <FaMap style={{ color: '#94a3b8', marginRight: '10px' }} />,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    className={styles.inputField}
                    name="proveedor"
                    label="Proveedor"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={formValues.proveedor}
                    onChange={handleChange}
                    InputProps={{
                      startAdornment: <FaTruckLoading style={{ color: '#94a3b8', marginRight: '10px' }} />,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    className={styles.inputField}
                    name="factura"
                    label="N° Factura"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={formValues.factura}
                    onChange={handleChange}
                    InputProps={{
                      startAdornment: <FaFileInvoice style={{ color: '#94a3b8', marginRight: '10px' }} />,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    className={styles.inputField}
                    name="nit"
                    label="Nit Proveedor"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={formValues.nit}
                    onChange={handleChange}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* SECCIÓN 3: ESTADO Y VALOR */}
            <Grid item xs={12}>
              <div className={styles.sectionLabel}>
                <FaBuilding /> Estado y Financiero
              </div>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    className={styles.inputField}
                    name="estado"
                    label="Estado de Operación"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={formValues.estado}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    className={styles.inputField}
                    name="costoUnitario"
                    label="Valor de Adquisición"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={formValues.costoUnitario}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    className={styles.inputField}
                    name="observacion"
                    label="Observaciones"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={formValues.observacion}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4} sx={{ display: 'flex', alignItems: 'center' }}>
                  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', color: '#64748b', fontSize: '0.9rem' }}>
                    <input
                      type="checkbox"
                      name="esGestionTI"
                      checked={formValues.esGestionTI}
                      onChange={handleChange}
                      style={{ marginRight: '8px', width: '18px', height: '18px' }}
                    />
                    Activo de Gestión TI
                  </label>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} className={styles.buttonContainer}>
              <Button type="submit" variant="contained" className={styles.saveButton} startIcon={<FaSave />}>
                {editId ? 'Actualizar Activo' : 'Guardar Activo'}
              </Button>
              {editId && (
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    setEditId(null);
                    setFormValues({
                      codigo: '', fechaIngreso: '', equipo: '', tipoEquipo: '', marca: '', modeloTipo: '',
                      serie: '', costoUnitario: '', sede: '', dependencia: '', ubicacion_area: '', proveedor: '',
                      factura: '', nit: '', estado: '', observacion: '', esGestionTI: false, usuarioId: ''
                    });
                    setCodError(false);
                    setSerieError(false);
                  }}
                  sx={{ ml: 2, borderRadius: '12px', height: '44px', fontWeight: 'bold' }}
                >
                  Cancelar Edición
                </Button>
              )}
              <Button
                variant="outlined"
                className={styles.viewButton}
                onClick={handleOpenModal}
                startIcon={<FaListUl />}
              >
                Ver Inventario Actual
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: '20px',
            overflow: 'hidden',
            height: '90vh',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <div className={styles.modalHeader}>
          <Typography variant="h5" className={styles.modalTitle}>
            Inventario de Activos
          </Typography>
          <div className={styles.searchWrapper}>
            <Button
              variant="contained"
              onClick={exportToExcel}
              className={styles.saveButton}
              sx={{ borderRadius: "12px", height: '40px' }}
              startIcon={<FaFileExcel />}
            >
              Excel
            </Button>
            <TextField
              placeholder="Buscar activo..."
              variant="outlined"
              size="small"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setPage(0);
              }}
              InputProps={{
                startAdornment: <FaSearch style={{ color: '#94a3b8', marginRight: '10px' }} />,
              }}
              sx={{ width: 300 }}
            />
          </div>
        </div>

        <DialogContent sx={{ p: 0, backgroundColor: '#f8fafc', display: 'flex', flexDirection: 'column', overflow: 'hidden', flex: 1 }}>
          {loadingEquipos ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', flex: 1, py: 8 }}>
              <CircularProgress size={60} sx={{ color: '#2563eb', mb: 2 }} />
              <Typography variant="h6" color="textSecondary">
                Cargando inventario...
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Por favor espere un momento.
              </Typography>
            </Box>
          ) : equipos.length === 0 ? (
            <Box sx={{ textAlign: 'center', py: 8 }}>
              <FaBoxOpen size={48} color="#e2e8f0" />
              <Typography variant="body1" color="textSecondary" sx={{ mt: 2 }}>
                No hay equipos registrados en el sistema.
              </Typography>
            </Box>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
              <Box sx={{ flex: 1, overflow: 'auto', px: 3, pt: 2 }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: '#fff', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.07)' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#1e293b' }}>
                      <th style={{ color: '#fff', fontWeight: 700, textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.05em', padding: '14px 12px', whiteSpace: 'nowrap' }}>Código</th>
                      <th style={{ color: '#fff', fontWeight: 700, textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.05em', padding: '14px 12px', whiteSpace: 'nowrap' }}>Modelo</th>
                      <th style={{ color: '#fff', fontWeight: 700, textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.05em', padding: '14px 12px', whiteSpace: 'nowrap' }}>Serial</th>
                      <th style={{ color: '#fff', fontWeight: 700, textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.05em', padding: '14px 12px', whiteSpace: 'nowrap' }}>Tipo Equipo</th>
                      <th style={{ color: '#fff', fontWeight: 700, textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.05em', padding: '14px 12px', whiteSpace: 'nowrap' }}>Equipo</th>
                      <th style={{ color: '#fff', fontWeight: 700, textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.05em', padding: '14px 12px', whiteSpace: 'nowrap' }}>Marca</th>
                      <th style={{ color: '#fff', fontWeight: 700, textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.05em', padding: '14px 12px', whiteSpace: 'nowrap' }}>Fecha</th>
                      <th style={{ color: '#fff', fontWeight: 700, textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.05em', padding: '14px 12px', whiteSpace: 'nowrap' }}>Valor</th>
                      <th style={{ color: '#fff', fontWeight: 700, textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.05em', padding: '14px 12px', whiteSpace: 'nowrap' }}>Sede</th>
                      <th style={{ color: '#fff', fontWeight: 700, textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.05em', padding: '14px 12px', whiteSpace: 'nowrap' }}>Dependencia</th>
                      <th style={{ color: '#fff', fontWeight: 700, textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.05em', padding: '14px 12px', whiteSpace: 'nowrap' }}>Ubicación</th>
                      <th style={{ color: '#fff', fontWeight: 700, textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.05em', padding: '14px 12px', whiteSpace: 'nowrap' }}>Usuario Asignado</th>
                      <th style={{ color: '#fff', fontWeight: 700, textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.05em', padding: '14px 12px', whiteSpace: 'nowrap' }}>Proveedor</th>
                      <th style={{ color: '#fff', fontWeight: 700, textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.05em', padding: '14px 12px', whiteSpace: 'nowrap' }}>Factura</th>
                      <th style={{ color: '#fff', fontWeight: 700, textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.05em', padding: '14px 12px', whiteSpace: 'nowrap' }}>Nit</th>
                      <th style={{ color: '#fff', fontWeight: 700, textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.05em', padding: '14px 12px', whiteSpace: 'nowrap' }}>Observación</th>
                    </tr>
                  </thead>
                  <tbody>
                  {paginatedData.length > 0 ? (
                    paginatedData.map((item, index) => (
                      <tr
                        key={item.equipo.id || index}
                        onDoubleClick={() => {
                          setEditId(item.equipo.id);
                          setFormValues({
                            codigo: item.equipo.cod || '',
                            fechaIngreso: item.equipo.fechacompra ? item.equipo.fechacompra.split('T')[0] : '',
                            equipo: item.equipo.tipoequipoId || '',
                            tipoEquipo: item.equipo.tipodeequipoId || '',
                            marca: item.equipo.MarcaId || '',
                            modeloTipo: item.equipo.modelo || '',
                            serie: item.equipo.serial || '',
                            costoUnitario: item.equipo.valor ? formatCurrency(item.equipo.valor.toString()) : '',
                            sede: item.equipo.sede || '',
                            dependencia: item.equipo.dependencia || '',
                            ubicacion_area: item.equipo.ubicacion_area || '',
                            proveedor: item.equipo.proveedor || '',
                            factura: item.equipo.factura || '',
                            nit: item.equipo.nit || '',
                            estado: item.equipo.estado || '',
                            observacion: item.equipo.observacion || '',
                            esGestionTI: item.equipo.Proceso !== 2,
                            usuarioId: item.usuarioAsignado ? item.usuarioAsignado.id : '',
                          });
                          setCodError(false);
                          setSerieError(false);
                          setOpenModal(false);
                        }}
                        style={{ cursor: 'pointer', backgroundColor: index % 2 === 0 ? '#fff' : '#f8fafc', transition: 'background 0.15s' }}
                        onMouseEnter={e => e.currentTarget.style.backgroundColor = '#e0f2fe'}
                        onMouseLeave={e => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#fff' : '#f8fafc'}
                        title="Doble clic para editar este activo"
                      >
                        <td style={{ padding: '10px 12px', fontWeight: 700, color: '#1e293b', whiteSpace: 'nowrap', borderBottom: '1px solid #f1f5f9' }}>{item.equipo.cod}</td>
                        <td style={{ padding: '10px 12px', whiteSpace: 'nowrap', borderBottom: '1px solid #f1f5f9' }}>{item.equipo.modelo}</td>
                        <td style={{ padding: '10px 12px', whiteSpace: 'nowrap', borderBottom: '1px solid #f1f5f9' }}>{item.equipo.serial}</td>
                        <td style={{ padding: '10px 12px', whiteSpace: 'nowrap', borderBottom: '1px solid #f1f5f9' }}>{item.tipodeequipo?.descripcion}</td>
                        <td style={{ padding: '10px 12px', whiteSpace: 'nowrap', borderBottom: '1px solid #f1f5f9' }}>{item.tipoequipo?.descripcionte}</td>
                        <td style={{ padding: '10px 12px', whiteSpace: 'nowrap', borderBottom: '1px solid #f1f5f9' }}>{item.marca?.marca}</td>
                        <td style={{ padding: '10px 12px', whiteSpace: 'nowrap', borderBottom: '1px solid #f1f5f9' }}>{item.equipo?.fechacompra ? new Date(item.equipo.fechacompra).toLocaleDateString('es-ES') : '-'}</td>
                        <td style={{ padding: '10px 12px', fontWeight: 600, color: '#10b981', whiteSpace: 'nowrap', borderBottom: '1px solid #f1f5f9' }}>${item.equipo?.valor?.toLocaleString('es-CO')}</td>
                        <td style={{ padding: '10px 12px', whiteSpace: 'nowrap', borderBottom: '1px solid #f1f5f9' }}>{item.equipo?.sede}</td>
                        <td style={{ padding: '10px 12px', whiteSpace: 'nowrap', borderBottom: '1px solid #f1f5f9' }}>{item.equipo?.dependencia}</td>
                        <td style={{ padding: '10px 12px', whiteSpace: 'nowrap', borderBottom: '1px solid #f1f5f9' }}>{item.equipo?.ubicacion_area}</td>
                        <td style={{ padding: '10px 12px', whiteSpace: 'nowrap', borderBottom: '1px solid #f1f5f9', color: item.usuarioAsignado ? '#2563eb' : '#94a3b8', fontStyle: item.usuarioAsignado ? 'normal' : 'italic' }}>{item.usuarioAsignado ? item.usuarioAsignado.nombre : 'Sin asignar'}</td>
                        <td style={{ padding: '10px 12px', whiteSpace: 'nowrap', borderBottom: '1px solid #f1f5f9' }}>{item.equipo?.proveedor}</td>
                        <td style={{ padding: '10px 12px', whiteSpace: 'nowrap', borderBottom: '1px solid #f1f5f9' }}>{item.equipo?.factura}</td>
                        <td style={{ padding: '10px 12px', whiteSpace: 'nowrap', borderBottom: '1px solid #f1f5f9' }}>{item.equipo?.nit}</td>
                        <td style={{ padding: '10px 12px', minWidth: '180px', borderBottom: '1px solid #f1f5f9' }}>{item.equipo?.observacion}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={16} style={{ textAlign: 'center', padding: '40px', color: '#94a3b8', fontStyle: 'italic' }}>
                        No se encontraron resultados para su búsqueda.
                      </td>
                    </tr>
                  )}
                  </tbody>
                </table>
              </Box>
              {/* Paginación fija fuera del scroll */}
              <Box sx={{ borderTop: '1px solid #e2e8f0', backgroundColor: '#fff', px: 2, flexShrink: 0 }}>
                <TablePagination
                  component="div"
                  count={filteredEquipos.length}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  rowsPerPageOptions={[10]}
                  labelRowsPerPage="Filas:"
                  labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count} activos`}
                />
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 3, borderTop: '1px solid #f1f5f9' }}>
          <Button onClick={handleCloseModal} className={styles.viewButton}>Cerrar Ventana</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openTipoModal} onClose={() => setOpenTipoModal(false)} maxWidth="sm" fullWidth>
        <div className={styles.modalHeader}>
          <Typography variant="h6" className={styles.modalTitle}>
            Crear Nuevo Tipo de Equipo
          </Typography>
        </div>
        <DialogContent sx={{ p: 3 }}>
          <TextField
            autoFocus
            margin="dense"
            label="Nombre del Tipo de Equipo"
            type="text"
            fullWidth
            variant="outlined"
            value={nuevoTipo}
            onChange={(e) => setNuevoTipo(e.target.value)}
          />
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button onClick={() => setOpenTipoModal(false)} color="secondary">
            Cancelar
          </Button>
          <Button onClick={handleCreateTipoEquipo} variant="contained" className={styles.saveButton}>
            Crear
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default FormularioEquipo;
